import {useEffect, useState} from "react";
import {Button, Card, CardActions, CardContent, TextField} from "@mui/material";
import {useTranslation} from "react-i18next";
import {MAX_CHAR_BODY_NOTE} from "../../config";

const NewNote = ({show, onClose, onSave}: {show: boolean, onClose: Function, onSave: Function}) => {

    const {t} = useTranslation('network');
    const maxChar = MAX_CHAR_BODY_NOTE;

    const [body, setBody] = useState<string>('');

    // Use Callback
    const handleClickSave = () => {
        if (!!body && !!onSave) {
            onSave(body);
        }
    };

    const handleOnClose = (e: React.BaseSyntheticEvent) => {
        if (!!e) {
            e.stopPropagation();
        }

        if (!!onClose) {
            onClose();
        }
    }

    // Use Effect
    useEffect(() => {
        if (!show)
            setBody('');
    }, [show])

    return (
        show ?
            <>
                <Card
                    variant="outlined"
                    sx={{
                        borderColor: 'primary.main'
                    }}
                >
                    <CardContent>
                        <TextField
                            value={body}
                            onChange={(e) => setBody(e.target.value)}
                            placeholder={t('raDetail.notes.placeholder')}
                            autoFocus
                            fullWidth
                            multiline
                            maxRows={30}
                            InputProps={{
                                disableUnderline: true
                            }}
                            error={body.length > maxChar}
                            helperText={body.length + ' / ' + maxChar}
                            FormHelperTextProps={{
                                component: "div"
                            } as any}
                        />
                    </CardContent>
                    <CardActions>
                        <Button onClick={handleClickSave}
                                disabled={!body}>
                            {t('raDetail.notes.button.save')}
                        </Button>

                        <Button variant="outlined" onClick={handleOnClose}>
                            {t('raDetail.notes.button.cancel')}
                        </Button>
                    </CardActions>
                </Card>
            </> :
            <></>
    );

}

export default NewNote;
